(() => {
  const root = document.querySelector('[data-mtu-root]');
  if (!root) return;

  const loadingEl = root.querySelector('[data-mtu-loading]');
  const emptyEl = root.querySelector('[data-mtu-empty]');
  const errorEl = root.querySelector('[data-mtu-error]');
  const cards = Array.from(root.querySelectorAll('[data-mtu-card]'));

  const storeDomain = root.dataset.storeDomain || 'nutrition-su.myshopify.com';
  const apiVersion = root.dataset.apiVersion || '2025-10';
  const token = root.dataset.storefrontToken || '76d349f53add8fb2f0560350acfc089f';
  const cartBase = root.dataset.cartBase || '/cart/add';

  const params = new URLSearchParams(window.location.search);
  const itemsParam = params.get('items');
  const nameParam = params.get('name') || params.get('customer_name');
  const customerNameEl = root.querySelector('[data-mtu-customer-name]');

  const customerName = (nameParam || root.dataset.customerName || '').trim();
  if (customerNameEl && customerName) {
    const suffix = customerName === 'あなた' || customerName.endsWith('様') ? '' : '様';
    customerNameEl.textContent = `${customerName}${suffix}`;
  }

  const showState = (state) => {
    if (loadingEl) loadingEl.hidden = state !== 'loading';
    if (emptyEl) emptyEl.hidden = state !== 'empty';
    if (errorEl) errorEl.hidden = state !== 'error';

    // 'ready'の場合は全てのステータスを非表示
    if (state === 'ready') {
      if (loadingEl) loadingEl.hidden = true;
      if (emptyEl) emptyEl.hidden = true;
      if (errorEl) errorEl.hidden = true;
    }
  };

  const formatPrice = (amount, currencyCode) => {
    if (!amount || !currencyCode) return '価格未取得';
    try {
      return new Intl.NumberFormat('ja-JP', {
        style: 'currency',
        currency: currencyCode
      }).format(Number(amount));
    } catch (e) {
      return `${amount} ${currencyCode}`;
    }
  };

  const escapeHtml = (value) => String(value ?? '').replace(/[&<>"']/g, (char) => ({
    '&': '&amp;',
    '<': '&lt;',
    '>': '&gt;',
    '"': '&quot;',
    "'": '&#39;'
  }[char]));

  const supplementDescriptions = [
    {
      keywords: ['マグネシウム'],
      text: '筋肉や神経の機能維持、エネルギー代謝に欠かせないミネラル'
    },
    {
      keywords: ['ヘム鉄', '鉄'],
      text: '酸素を全身に運ぶ重要ミネラル'
    },
    {
      keywords: ['亜鉛', 'Zn'],
      text: '細胞分裂や酵素反応を支える必須ミネラル'
    },
    {
      keywords: ['ビタミンD', 'Vitamin D'],
      text: 'カルシウム吸収を助ける脂溶性ビタミン'
    },
    {
      keywords: ['ビタミンC', 'Vitamin C'],
      text: '美容と健康維持、抗酸化サポートに役立つ水溶性ビタミン'
    },
    {
      keywords: ['ビタミンB', 'Vitamin B', 'B群'],
      text: 'エネルギー産生を支える補酵素群'
    },
    {
      keywords: ['葉酸'],
      text: '赤血球の形成や細胞の生まれ変わりを支えるビタミンB群の一種'
    },
    {
      keywords: ['クリルオイル', 'DHA', 'EPA', 'オメガ3', 'オメガ３', 'オメガ3脂肪酸', 'Omega'],
      text: '体内で作れない必須脂肪酸'
    },
    {
      keywords: ['コエンザイム', 'コエンザイムQ10', 'CoQ10', 'Coenzyme', 'ユビキノン'],
      text: '細胞の発電所を支える補酵素'
    },
    {
      keywords: ['乳酸菌', 'プロバイオティクス'],
      text: '腸内環境を整え、内側からの健康維持をサポートする善玉菌'
    },
    {
      keywords: ['カルシウム', 'Ca'],
      text: '骨や歯の形成を支え、健康な体づくりに欠かせないミネラル'
    },
    {
      keywords: ['マルチビタミン', 'マルチミネラル'],
      text: '不足しがちなビタミン・ミネラルをまとめて補うベースサプリ'
    }
  ];

  const getSupplementDescription = (productTitle, variantTitle, fallbackDescription) => {
    const target = `${productTitle || ''} ${variantTitle || ''}`.toLowerCase();
    const matched = supplementDescriptions.find((item) => (
      item.keywords.some((keyword) => target.includes(keyword.toLowerCase()))
    ));
    return matched ? matched.text : summarizeText(fallbackDescription);
  };

  const summarizeText = (value, maxLength = 90) => {
    const text = String(value || '')
      .replace(/■\s*商品説明/g, '')
      .replace(/商品説明/g, '')
      .replace(/\s+/g, ' ')
      .trim();
    if (!text) return '今のあなたに必要な栄養素を補うためのサプリメントです。';
    return text.length > maxLength ? `${text.slice(0, maxLength)}…` : text;
  };

  const parseItems = (raw) => {
    if (!raw) return [];
    return raw.split(',').map((chunk) => {
      const [idRaw, qtyRaw] = chunk.split(':');
      const id = (idRaw || '').trim();
      if (!/^\d+$/.test(id)) return null;
      const qty = parseInt((qtyRaw || '').trim(), 10);
      return {
        id,
        qty: Number.isFinite(qty) && qty > 0 ? qty : 1
      };
    }).filter(Boolean);
  };

  const regularToSubMap = {
    '42836103561318': '43456652116070',
    '42835651788902': '43456652148838',
    '42836121288806': '43456651591782',
    '42836113981542': '43456651821158',
    '42836119093350': '43456651755622',
    '42836110508134': '43456651853926',
  };

  const subToRegularMap = Object.fromEntries(
    Object.entries(regularToSubMap).map(([regularId, subId]) => [subId, regularId])
  );

  const normalizeItems = (planItems, variantMap) => (
    planItems.map((item) => ({
      ...item,
      id: variantMap[item.id] || item.id
    }))
  );

  const buildSwitchUrl = (pathname, mappedItems) => {
    if (!mappedItems || mappedItems.length === 0) return null;
    const targetParams = new URLSearchParams();
    targetParams.set('items', mappedItems.join(','));
    if (nameParam) {
      targetParams.set(params.has('customer_name') ? 'customer_name' : 'name', nameParam);
    }
    return `${pathname}?${targetParams.toString()}`;
  };

  const setSecondaryLink = (link, href) => {
    if (!link || !href) return;
    link.setAttribute('href', href);
    link.removeAttribute('aria-disabled');
    link.style.display = 'block';
  };

  const isPlainLeftClick = (event) => (
    event.button === 0 && !event.metaKey && !event.ctrlKey && !event.shiftKey && !event.altKey
  );

  const items = normalizeItems(parseItems(itemsParam), subToRegularMap);
  if (items.length === 0) {
    showState('empty');
    cards.forEach((card) => card.classList.add('is-hidden'));
    return;
  }

  // pages/ume はおすすめサプリ1件を表示する。
  const visiblePlans = ['ume'];

  cards.forEach((card) => {
    const plan = card.getAttribute('data-plan');
    if (!visiblePlans.includes(plan)) {
      card.classList.add('is-hidden');
    }
  });

  const planItemsMap = new Map();
  cards.forEach((card) => {
    const plan = card.getAttribute('data-plan');
    if (!visiblePlans.includes(plan)) return;
    const indices = (card.getAttribute('data-indices') || '')
      .split(',')
      .map((value) => parseInt(value, 10))
      .filter((value) => Number.isFinite(value));
    const planItems = indices.map((idx) => items[idx]).filter(Boolean);
    planItemsMap.set(plan, planItems);
  });

  const buildCartUrl = (planItems) => {
    if (!planItems || planItems.length === 0) return null;
    const cartParams = new URLSearchParams();
    planItems.forEach((item, index) => {
      cartParams.append(`items[${index}][id]`, item.id);
      cartParams.append(`items[${index}][quantity]`, String(item.qty));
    });
    cartParams.append('return_to', '/cart');
    return `${cartBase}?${cartParams.toString()}`;
  };

  // カート追加ボタンの初期設定（商品情報取得前でも遷移できるようにする）
  cards.forEach((card) => {
    const plan = card.getAttribute('data-plan');
    if (!visiblePlans.includes(plan)) return;
    const planItems = planItemsMap.get(plan) || [];
    const cartButton = card.querySelector('[data-mtu-cart-button]');
    const subLink = card.querySelector('[data-mtu-sub-link]');

    if (cartButton) {
      const cartUrl = buildCartUrl(planItems);
      if (!cartUrl) {
        cartButton.setAttribute('href', '#');
        cartButton.setAttribute('aria-disabled', 'true');
      } else {
        cartButton.setAttribute('href', cartUrl);
        cartButton.removeAttribute('aria-disabled');
      }
    }

    if (subLink && planItems.length > 0) {
      const subItems = planItems
        .map((item) => regularToSubMap[item.id] ? `${regularToSubMap[item.id]}:${item.qty}` : null)
        .filter(Boolean);
      setSecondaryLink(subLink, buildSwitchUrl('/pages/ume-subscription', subItems));
    }
  });

  root.addEventListener('click', (event) => {
    const target = event.target instanceof Element
      ? event.target.closest('[data-mtu-sub-link]')
      : null;
    if (!target || !isPlainLeftClick(event)) return;

    const href = target.getAttribute('href');
    if (!href || href === '#' || target.getAttribute('aria-disabled') === 'true') return;

    event.preventDefault();
    window.location.assign(target.href);
  }, true);

  root.addEventListener('click', (event) => {
    const target = event.target instanceof Element
      ? event.target.closest('[data-mtu-cart-button]')
      : null;
    if (!target) return;
    const card = target.closest('[data-mtu-card]');
    if (!card) return;
    const plan = card.getAttribute('data-plan');
    const planItems = planItemsMap.get(plan) || [];
    const cartUrl = buildCartUrl(planItems);
    if (!cartUrl) return;
    event.preventDefault();
    window.location.assign(cartUrl);
  }, true);

  const variantIds = Array.from(new Set(
    Array.from(planItemsMap.values()).flat().map((item) => item.id)
  ));

  // デバッグ: variant IDsを確認
  console.log('Variant IDs:', variantIds);

  // GIDをBase64に変換（Storefront APIのID形式に合わせる）
  const gidList = variantIds.map((id) => {
    const gid = `gid://shopify/ProductVariant/${id}`;
    try {
      return btoa(gid);
    } catch (e) {
      return gid;
    }
  });

  // デバッグ: GIDリストを確認
  console.log('GID List:', gidList);

  const query = `query VariantNodes($ids: [ID!]!) {
    nodes(ids: $ids) {
      ... on ProductVariant {
        id
        title
        price {
          amount
          currencyCode
        }
        compareAtPrice {
          amount
          currencyCode
        }
        product {
          title
          vendor
          productType
          description
          tags
          onlineStoreUrl
          featuredImage {
            url
            altText
          }
        }
      }
    }
  }`;

  const fetchVariants = () => fetch(`https://${storeDomain}/api/${apiVersion}/graphql.json`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'X-Shopify-Storefront-Access-Token': token
    },
    body: JSON.stringify({
      query,
      variables: { ids: gidList }
    })
  }).then((res) => {
    if (!res.ok) throw new Error('Storefront API request failed');
    return res.json();
  });

  showState('loading');

  fetchVariants()
    .then((payload) => {
      // デバッグ: APIレスポンスを確認
      console.log('API Response:', payload);

      if (payload?.errors?.length) {
        console.error('GraphQL errors:', payload.errors);
        throw new Error('Storefront API returned errors');
      }
      const nodes = (payload && payload.data && payload.data.nodes) || [];

      // デバッグ: nodesを確認
      console.log('Nodes:', nodes);

      const variantMap = new Map();

      nodes.forEach((node) => {
        if (!node || !node.id) return;
        const idMatch = node.id.match(/ProductVariant\/(\d+)/);
        if (!idMatch) return;
        variantMap.set(idMatch[1], node);
      });

      let missingVariants = 0;

      cards.forEach((card) => {
        const plan = card.getAttribute('data-plan');
        if (!visiblePlans.includes(plan)) return;
        const planItems = planItemsMap.get(plan) || [];
        const listEl = card.querySelector('[data-mtu-items]');
        const priceEl = card.querySelector('[data-mtu-price]');
        const originalPriceEl = card.querySelector('[data-mtu-original-price]');
        const discountEl = card.querySelector('[data-mtu-discount]');
        const cartButton = card.querySelector('[data-mtu-cart-button]');
        const buttonLabelEl = card.querySelector('[data-mtu-button-label]');

        if (!listEl) return;
        listEl.innerHTML = '';

        let totalPrice = 0;           // 現在の価格（割引後）の合計
        let totalCompareAtPrice = 0;  // 元の価格（compareAtPrice）の合計
        let currencyCode = 'JPY';

        planItems.forEach((item) => {
          const data = variantMap.get(item.id);
          if (!data) missingVariants += 1;
          const productTitle = data?.product?.title || '商品名未取得';
          const variantTitle = data?.title || '';
          const displayName = variantTitle && variantTitle !== 'Default Title'
            ? `${productTitle} - ${variantTitle}`
            : productTitle;
          const price = data?.price?.amount;
          const compareAtPrice = data?.compareAtPrice?.amount;
          const productType = data?.product?.productType || data?.product?.vendor || 'ワカサプリ';
          const productDescription = getSupplementDescription(productTitle, variantTitle, data?.product?.description);
          const imageUrl = data?.product?.featuredImage?.url || '';
          const imageAlt = data?.product?.featuredImage?.altText || displayName;
          currencyCode = data?.price?.currencyCode || currencyCode;

          // 現在の価格を加算
          if (price) {
            totalPrice += Number(price) * item.qty;
          }

          // 元の価格を加算（compareAtPriceがある場合はそれ、なければpriceを使用）
          if (compareAtPrice) {
            totalCompareAtPrice += Number(compareAtPrice) * item.qty;
          } else if (price) {
            totalCompareAtPrice += Number(price) * item.qty;
          }

          const li = document.createElement('li');
          li.className = 'mtu__item';
          const imageHtml = imageUrl
            ? `<img src="${escapeHtml(imageUrl)}" alt="${escapeHtml(imageAlt)}" class="mtu__item-image">`
            : '';
          const productMainClass = imageUrl
            ? 'mtu__product-main'
            : 'mtu__product-main mtu__product-main--no-image';

          const itemPrice = price ? formatPrice(Number(price) * item.qty, currencyCode) : '';

          li.innerHTML = `
            <div class="${productMainClass}">
              ${imageHtml}
              <div class="mtu__product-info">
                <div class="mtu__product-label">あなたにおすすめの製品</div>
                <div class="mtu__product-brand">${escapeHtml(productType)}</div>
                <div class="mtu__product-title">
                  ${escapeHtml(displayName)}${!data ? ` <small class="mtu__product-id">(ID: ${escapeHtml(item.id)})</small>` : ''}
                </div>
                <p class="mtu__product-desc">${escapeHtml(productDescription)}</p>
                <div class="mtu__item-footer">
                  <div class="mtu__product-tags">
                    <span class="mtu__product-tag">医療機関専売品質</span>
                    <span class="mtu__product-tag">高吸収率</span>
                  </div>
                  ${itemPrice ? `<div class="mtu__item-price">${itemPrice}</div>` : ''}
                </div>
              </div>
            </div>
          `;
          listEl.appendChild(li);
        });

        // 割引率を計算（元の価格と現在の価格から）
        const hasDiscount = totalCompareAtPrice > totalPrice;
        const discountRate = hasDiscount
          ? (totalCompareAtPrice - totalPrice) / totalCompareAtPrice
          : 0;

        // 価格表示（現在の価格 = 割引後の価格）
        if (priceEl) {
          priceEl.textContent = totalPrice
            ? formatPrice(totalPrice, currencyCode)
            : '価格未取得';
        }

        // 元の価格表示（割引がある場合のみ）
        if (originalPriceEl && hasDiscount) {
          originalPriceEl.textContent = formatPrice(totalCompareAtPrice, currencyCode);
          originalPriceEl.hidden = false;
        }

        // 割引バッジ表示（割引がある場合のみ）
        if (discountEl && hasDiscount && discountRate > 0) {
          discountEl.textContent = `${Math.round(discountRate * 100)}% OFF`;
          discountEl.hidden = false;
        }

        if (buttonLabelEl) {
          buttonLabelEl.textContent = 'サプリを購入する';
        }

        // カート追加URL生成（このカード専用）
        if (cartButton && planItems.length > 0) {
          const cartParams = new URLSearchParams();
          planItems.forEach((item, index) => {
            cartParams.append(`items[${index}][id]`, item.id);
            cartParams.append(`items[${index}][quantity]`, String(item.qty));
          });
          cartParams.append('return_to', '/cart');
          const cartUrl = `${cartBase}?${cartParams.toString()}`;
          cartButton.setAttribute('href', cartUrl);
          cartButton.removeAttribute('aria-disabled');

          // デバッグ: カートURLを確認
          console.log(`${plan} プランのカートURL:`, cartUrl);
        }
      });

      if (missingVariants > 0 && errorEl) {
        errorEl.textContent = `商品情報を取得できないIDが${missingVariants}件あります。オンラインストアに公開されているか、Storefront APIトークンが正しいか確認してください。`;
        showState('error');
      } else {
        showState('ready');
      }
    })
    .catch((error) => {
      console.error('Storefront API error:', error);
      if (errorEl) {
        errorEl.textContent = '商品情報の取得に失敗しました。ネットワーク接続やAPIトークンを確認してください。';
      }
      showState('error');
    });
})();
